import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/leagues/leagues-list/filter'; // Importing Filter component
import Table from 'views/leagues/leagues-list/table'; // Importing Table component
import TableResult from 'views/leagues/results/recordTableResponts'; // Importing TableResult component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * LeaguesListView class extends JetView to create a view for leagues list.
 */
export default class LeaguesListView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Configuration for the right section
            type: 'wide',
            minWidth: 200,
            rows: [TableResult], // Including TableResult component
        };
        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        const left = {
            // Configuration for the left section
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label for the leagues list title
                            label: _('Lista de Ligas'),
                            width: 150,
                        },
                    ],
                },
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar, // Including the previously defined toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left, { id: 'res', view: 'resizer' }, right], // Layout structure with left, resizer, and right sections
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check screen width for responsiveness
                $$('res').hide(); // Hide the resizer if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
